let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2lsjy")).then(() => parcelRequire('8no1X'));